import { PROD } from 'utils/constants';

export const GET_FEATURE_TOGGLE_URL = {
  url: '/common/feature-toggle',
  method: 'POST',
};

export const VENDOR_DATA_BY_ID_URL = {
  url: `/pg/settlements/split/vendors/$vendor_id$`,
  method: 'GET',
};

export const FETCH_EASY_SPLIT_CONFIG_URL = {
  url: '/pg/settlements/split/config',
  method: 'GET',
};

export const GET_SSO_CONFIG_URL = {
  url: '/common/saml-config',
  method: 'GET',
};

export const UPDATE_EASY_SPLIT_CONFIG_URL = {
  url: '/pg/settlements/split/config',
  method: 'POST',
};

export const DOWNLOAD_DOCUMENT_URL = {
  url: '/common/docs/download',
  method: 'GET',
};

export const GENERATE_SETTLEMENTS_REPORTS_URL = {
  url: '/pg/report/recon',
  method: 'GET',
};

export const SEARCH_SETTLEMENTS_VENDOR_URL = {
  url: '/pg/settlements/split/extended-payouts/search',
  method: 'GET',
};

export const GET_ALL_MERCHANT_ROUTES_URL = {
  url: '/router/merchant/routes',
  method: 'GET',
};

export const GET_ACTIVE_MERCHANT_ROUTES_URL = {
  url: '/router/merchant/routes/status/active',
  method: 'GET',
};

export const CREATE_MERCHANT_ROUTE_URL = {
  url: '/router/merchant/routes',
  method: 'POST',
};

export const GENERATE_REPORT_URL = {
  url: '/pg/report/summary',
  method: 'GET',
};

export const SEARCH_OFFERS_URL = {
  url: '/pg/offers/search',
  method: 'GET',
};

export const UPDATE_OFFERS_URL = {
  url: '/pg/offers/$offerId$/update',
  method: 'PUT',
};

export const GET_MERCHANT_PG_CONFIG_URL = {
  url: '/pg/merchant-pg-config',
  method: 'GET',
};

export const GET_OFFERS_METADATA_URL = {
  url: '/pg/offers/offers-meta-data',
  method: 'GET',
};

export const GET_NO_COST_EMI_METADATA_URL = {
  url: '/pg/offers/no-cost-emi/details',
  method: 'GET',
};

export const CHECK_ON_DEMAND_ELIGIBILITY_URL = {
  url: '/pg/ondemand/eligible',
  method: 'GET',
};

export const ACTIVATE_ON_DEMAND_SETTLEMENTS_INSTANTLY_URL = {
  url: '/pg/ondemand/activate?source=MERCHANT_DASHBOARD',
  method: 'POST',
};

export const ACTIVATE_FREE_TRIAL_URL = {
  url: '/pg/od-free-trial/activate',
  method: 'POST',
};

export const UPDATE_FREE_TRIAL_STATUS_URL = {
  url: '/pg/od-free-trial/status',
  method: 'POST',
};

export const EXTEND_FREE_TRIAL_URL = {
  url: '/pg/od-free-trial/extend',
  method: 'POST',
};

export const GET_FREE_TRIAL_NUDGE_URL = {
  url: '/pg/od-free-trial/nudge',
  method: 'GET',
};

export const GET_REG_DETAILS_URL = {
  url: '/common/reg-details/get',
  method: 'GET',
};

export const GET_MERCHANT_DOCS_URL = {
  url: '/common/merchant-docs/get',
  method: 'GET',
};
export const GET_MERCHANT_DOC_URL = {
  url: '/common/upload/get',
  method: 'GET',
};
export const GET_SELECTED_REG_DETAILS_URL = {
  url: '/common/reg-details',
  method: 'POST',
};

export const GET_ACTIVE_GSTS = {
  url: '/common/onboardingsvc/active-gsts',
  method: 'GET',
};

export const VERIFY_GSTIN_URL = {
  url: '/ob/auto-verify/gstin',
  method: 'POST',
};

export const FETCH_ONBOARDING_META_DATA_URL = {
  url: '/ob/onboarding-meta-data/domain-details',
  method: 'POST',
};

export const UPDATE_ADDRESS_URL = {
  url: '/ob/autofill/merchant/custom-address-field',
  method: 'POST',
};

export const GET_WHITELISTING_DATA_URL = {
  url: '/ob/whitelisting-summary',
  method: 'GET',
};

export const GET_PAYMENT_METHODS_DATA_URL = {
  url: '/pg/payment-modes',
  method: 'GET',
};

export const POST_WHITELISTING_URL = {
  url: '/ob/secondary-domain-whitelisting',
  method: 'POST',
};

export const CHECK_WEBSITE_LIVENESS_URL = {
  url: '/ob/website-check',
  method: 'GET',
};

export const UPDATE_WHITELISTING_URL = {
  url: '/ob/secondary-domain-whitelisting/update-domain-status',
  method: 'POST',
};

export const GET_PAYOUT_BANK_IDS_URL = {
  method: 'GET',
  url: '/common/payout-ids',
};

export const CREATE_SELF_SERVE_TICKET_URL = {
  method: 'POST',
  url: '/ob/self-serve/ticket',
};

export const VERIFY_BANK_ACCOUNT_URL = {
  url: '/ob/self-serve/bav',
  method: 'POST',
};

export const CANCEL_NEW_BANK_ACCOUNT_URL = {
  url: '/ob/verification/self-serve-bav/cancellation',
  method: 'DELETE',
};

export const CLOSE_BANNER_URL = {
  url: '/ob/banner',
  method: 'POST',
};

export const GET_MERCHANT_DETAILS_URL = {
  url: '/common/merchant-details/get',
  method: 'GET',
};

export const UPSERT_MERCHANT_REG_DETAILS_URL = {
  url: '/common/merchant-reg-details/upsert',
  method: 'POST',
};

export const RESEND_EMAIL_URL = {
  url: '/common/email/resend/verification',
  method: 'GET',
};

export const UPLOAD_DOCS_URL = {
  url: '/common/docs/upload',
  method: 'POST',
};

export const GET_2FA_SETTINGS_URL = {
  url: '/common/2fa/settings',
  method: 'GET',
};
export const VALIDATE_2FA_URL = {
  url: '/common/2fa/validate',
  method: 'GET',
};
export const VERIFY_2FA_URL = {
  url: '/common/2fa/verify',
  method: 'POST',
};
export const SEND_2FA_OTP_URL = {
  url: '/common/2fa/send',
  method: 'GET',
};
export const GET_SPLIT_VENDOR_OPTIONS_URL = {
  url: '/pg/settlements/split/vendors/options',
  method: 'GET',
};

export const GET_ON_DEMAND_SETTLEMENT_STATUS_URL = {
  url: '/pg/ondemand/status',
  method: 'GET',
};

export const REQUEST_ON_DEMAND_ACTIVATION_URL = {
  url: '/pg/ondemand/activate',
  method: 'POST',
};

export const GET_MERCHANT_CREDITS_URL = {
  url: '/pg/settlements/credits',
  method: 'GET',
};

export const GET_PAYMENT_METHODS_URL = {
  url: '/pg/payment-modes',
  method: 'GET',
};

export const GET_ROUTER_ACTIVATION_STATUS_URL = {
  url: '/router/status',
  method: 'GET',
};

export const GET_PAYMET_MODES_ATTRIBUTES_DATA_URL = {
  url: '/pg/payment-method/filters',
  method: 'GET',
};

export const GET_NOTIFICATION_DATA_URL = {
  url: '/common/notifications',
  method: 'GET',
};

export const READ_ALL_NOTIFICATIONS_URL = {
  url: `/common/notifications/$idList$`,
  method: 'PATCH',
};

export const FETCH_SAR_STATUS_URL = {
  url: '/common/forms/responses/status',
  method: 'GET',
};

export const GET_ALL_ROUTES_URL = {
  url: '/router/routes',
  method: 'GET',
};

export const GET_ALL_RULE_ATTRIBUTES_URL = {
  url: '/router/rules/attributes',
  method: 'GET',
};

export const FRESHDESK_REDIRECT_URL = {
  url: `/common/freshdeskSSOUrl?nonce=$nonce$&state=$state$&redirectUri=$redirectUri$`,
  method: 'GET',
};

export const SEARCH_TRANSACTIONS_URL = {
  url: '/pg/transactions/search',
  method: 'GET',
};

export const GET_MERCHANT_CHECKLIST_PREFERENCE_URL = {
  url: '/pg/checklist/preference',
  method: 'PATCH',
  envCall: PROD,
};

export const DISMISS_MERCHANT_QUESTIONNAIRE_FORM_URL = {
  url: '/pg/questionnaire/dismiss',
  method: 'POST',
  envCall: PROD,
};

export const GET_MERCHANT_CHECKLIST_SOURCE_LIST = {
  url: '/pg/checklist/source-list',
  method: 'GET',
  envCall: PROD,
};

export const POST_MERCHANT_QUESTIONNAIRE_RESPONSE_URL = {
  url: '/pg/checklist/questionnaire',
  method: 'POST',
  envCall: PROD,
};

export const DISMISS_CHECKLIST_URL = {
  url: '/pg/checklist/dismiss',
  method: 'PATCH',
  envCall: PROD,
};

export const UPDATE_CHECKLIST_URL = {
  url: '/pg/checklist/update',
  method: 'PATCH',
  envCall: PROD,
};

export const GET_TNC_URL = {
  url: '/common/merchant/tnc-list',
  method: 'POST',
};

export const FORCE_RECON_URL = {
  url: '/pg/forced-recon',
  method: 'POST',
};

export const SEARCH_ORDERS_URL = {
  url: '/pg/pgorders/search',
  method: 'GET',
};

export const GET_ACTIVE_PAYMENT_MODES_URL = {
  url: '/pg/filters/payment-modes',
  method: 'GET',
};

export const GET_INSTANT_REFUNDS_FREE_TRIAL_ELIGIBILITY_URL = {
  url: '/pg/refund/instant-refunds/free-trial-eligibility',
  method: 'GET',
};

export const CREATE_FREE_TRIAL_WALLET_URL = {
  url: '/pg/refund/instant-refunds/create-free-trial-wallet',
  method: 'PUT',
};

export const GET_WALLET_STATUS_URL = {
  url: '/pg/refunds/wallets/reference',
  method: 'GET',
};

export const ADD_MONEY_TO_WALLET_URL = {
  url: '/pg/refunds/wallets/recharge-mode',
  method: 'GET',
};

export const ADD_MONEY_TO_DISPUTE_WALLET_URL = {
  url: '/pg/disputes/wallets/recharge-mode',
  method: 'GET',
};

export const UPDATE_MERCHANT_PG_CONFIG_URL = {
  method: 'PATCH',
  url: '/pg/merchant-pg-config',
};

export const CREATE_MERCHANT_PG_CONFIG_URL = {
  url: '/pg/merchant-pg-config',
  method: 'POST',
};

export const ACTIVATE_INSTANT_REFUND_URL = {
  method: 'PUT',
  url: '/pg/refund/instant-refunds/activate-instant-refund',
};

export const CREATE_ORDER_URL = {
  method: 'POST',
  url: '/pg/orders/new',
};

export const GET_TRANSACTION_ANALYTICS_URL = {
  method: 'POST',
  url: '/router/analytics/transaction',
};

export const GET_STATEWISE_TRANSACTION_ANALYTICS_URL = {
  method: 'POST',
  url: '/common/report/analytics/statewise',
};

export const GET_ERRORS_AGGREGATE_URL = {
  method: 'POST',
  url: '/router/analytics/errors/aggregates',
};

export const GET_TOP_PAYMENT_FAILURE_ERRORS_URL = {
  method: 'POST',
  url: '/router/analytics/top-errors',
};

export const GET_SHOPIFY_MERCHANT = {
  method: 'GET',
  url: '/pg/integration/details',
};

export const GOOGLE_SHEET_URL = {
  url:
    'https://script.google.com/macros/s/AKfycbzsNdaLGkE6SXOhbjmrVM7BIDP18ixGkxaVlMrP2A_UUuOuG1Cbex5HTqKisdKE5FsR/exec',
};

export const CHECK_FLOWWISE_ACTIVATION_URL = {
  method: 'GET',
  url: '/router/merchants/flowWiseActivation?checkActiveRule=true',
};

export const GET_WALLET_BANK_DETAILS_URL = {
  url: '/pg/settlements/merchant-beneficiaries/search',
  method: 'GET',
};

export const GET_ROUTE_CONFIG_PARAMS_URL = {
  url: '/router/routes/$routeId$/spec',
  method: 'GET',
};

export const GET_ROUTE_PAYMENT_MODE_URL = {
  url: '/router/paymodes/routes/$routeId$/status-hierarchy',
  method: 'GET',
};

export const UPDATE_ROUTE_PAYMENT_MODE_URL = {
  url: '/router/merchant/paymodes/routes/$merchantRouteId$',
  method: 'PUT',
};

export const GET_MERCHANT_CONFIG_URL = {
  url: '/router/merchants/$merchantId$/config/$configKey$',
  method: 'GET',
};

export const GET_PG_CAPTURE_CONFIG_URL = {
  url: '/pg/pg-capture-config',
  method: 'GET',
};

export const GET_PRODUCT_ACCESS_LEVEL = {
  url: '/common/partner/product/privilege',
  method: 'GET',
};

export const ACTIVATE_FLOWWISE_URL = {
  url: '/router/onboard/flowwise',
  method: 'POST',
};

export const GET_MERCHANT_GMV_RULE_CONFIG_URL = {
  url: '/router/merchants/gmv/config/rule-config/$ruleConfigId$',
  method: 'GET',
};

export const GET_FLOWWISE_EXPERIMENT_URL = {
  url: '/router/experiment/FLOWWISE_ACTIVATION/merchant',
  method: 'GET',
};

export const GET_GROUPED_PAYMENT_MODES_URL = {
  url: '/router/paymodes/routes/$merchantRouteId$/grouped',
  method: 'GET',
};

export const SYNC_ROUTE_PAYMENT_MODES_URL = {
  url: '/router/merchant/paymodes/routes/$merchantRouteId$/sync',
  method: 'POST',
};

export const UPDATE_FLOWWISE_EXPIREMENT_URL = {
  url: '/router/experiment/$experimentId$',
  method: 'POST',
};

export const GET_PRODUCT_FRUIT_CAMPAIGNS = {
  url: '/common/day0/user',
  method: 'GET',
};

export const DELETE_PRODUCT_FRUIT_CAMPAIGNS = {
  url: '/common/day0/user',
  method: 'PUT',
};

export const GET_INTEGRATION_STATUS_URL = {
  url: `/common/day0/user/$campaignName$/events`,
  method: 'GET',
};

export const UPDATE_INTEGRATION_STATUS_URL = {
  url: `/common/day0/user/events`,
  method: 'POST',
};

export const ANALYTICS_PRODUCT_FRUIT_CAMPAIGNS = {
  url: '/common/day0/analytics',
  method: 'POST',
};

export const GET_OFFER_PERFORMANCE_URL = {
  url: '/pg/offers/analytics/performance',
  method: 'GET',
};

export const GET_IMPORTS_SETTLEMENT_DETAILS_URL = {
  url: '/imports/settlement-details',
  method: 'GET',
};

export const GET_IMPORTS_VERIFICATION_DETAILS_URL = {
  url: '/imports/verification-details',
  method: 'GET',
};

export const GET_SEND_BIRD_URL = {
  url:
    '/chatbot/sendbird/issue-session-token?userId=$merchantId$&expiresAt=$expiresAt$',
  method: 'POST',
};

export const GET_IMPORTS_SUMMARY_SETTLEMENT_DETAILS_URL = {
  url: '/imports/settlement-details/recent',
  method: 'GET',
};

export const GET_MERCHANT_PRODUCT_STATUS_URL = {
  url: '/common/onboardingsvc/merchant/products-status',
  method: 'GET',
};

export const GET_BOT_PRESS_TOKEN = {
  url: '/common/support/botPressToken',
  method: 'POST',
};

export const CREATE_OFFER_URL = {
  url: '/pg/offers/create',
  method: 'POST',
};

export const GET_RISK_SHIELD_FLAGGED_AND_BLOCKED_TXNS_URL = {
  url: '/merchant/v1/risk-platform/pgdb/agg/flagged-txns',
  method: 'GET',
};

export const GET_TRANSACTIONS_SCANNED_URL = {
  url: '/merchant/v1/risk-platform/transaction/summary/transactions',
  method: 'POST',
};

export const FETCH_SMART_LIMITS = {
  url: '/merchant/v1/risk-platform/merchant/aggregated-rule/fetch',
  method: 'GET',
};

export const FETCH_CUSTOM_RULES = {
  url: '/merchant/v1/risk-platform/merchant/custom-risk-rules/PG',
  method: 'GET',
};

export const DR_INSIGHTS_ANALYTICS = {
  url: '/router/analytics/transaction',
  method: 'POST',
};

export const OCC_INTEGRATION_CUSTOM_WEBSITES_DOC_URL =
  'https://www.cashfree.com/docs/payments/checkout/integration-one-click-checkout';
